import type { App } from "vue"
import { dateZhCN, zhCN, enUS } from "naive-ui"
import { createI18n } from "vue-i18n"
import { localStg } from "@/utils/storage"
import messages from "./locale"

// 获取当前语言环境
// 如果没有设置，则默认为中文
// 如果设置了，则使用设置的语言环境
export function getLocale() {
    return localStg.get("lang") || "zh-CN"
}

// 设置 Naive UI 的语言环境
export function setNaiveLocale() {
    const locale = getLocale()
    if (locale === "zh-CN") {
        return {
            dateLocale: dateZhCN,
            locale: zhCN,
        }
    }
    return {
        dateLocale: dateZhCN,
        locale: enUS,
    }
}

// 如果url有传值需要设置语言环境

export function setLocaleFromUrl() {
    const url = new URL(window.location.href)
    const lang = url.searchParams.get("lang") as I18nType.LangType
    // 传值的语言环境 只需要中和英
    if (lang) {
        if (lang === "zh-CN") {
            localStg.set("lang", "zh-CN")
            getLocale()
            setLocale("zh-CN" as I18nType.LangType)
            return "zh-CN"
        }
        localStg.set("lang", "en")
        getLocale()
        setLocale("en" as I18nType.LangType)
        return "en"
    }
    return ""
}

const i18n = createI18n({
    locale: getLocale(),
    fallbackLocale: "en",
    messages,
    legacy: false,
})

export function setupI18n(app: App) {
    app.use(i18n)
}

export const $t = i18n.global.t

export function setLocale(locale: any) {
    i18n.global.locale.value = locale
}
